import { Col, Input, Modal, Radio, Row, Select } from '@oscar/theme';
import React, { useState } from 'react';

const { Option } = Select;
const { TextArea } = Input;

const optionsAccept = [
  { label: 'Accepted', value: true },
  { label: 'Rejected', value: false },
];

interface Props {
  handleCancel: () => void;
  handleSubmit: (actionProps: any) => void;
  visible: boolean;
}

const PopupFinalSubmitQaqc = (props: Props) => {
  const { handleCancel, visible, handleSubmit } = props;
  const [remarks, setRemarks] = useState('');
  const [overall, setOverall] = useState({
    overallAcceptance: true,
  });
  return (
    <div>
      <Modal
        closable={true}
        bodyStyle={{ width: '100%' }}
        visible={visible}
        title={'CIF Closure'}
        okText="Confirm"
        cancelText="Cancel"
        onCancel={() => handleCancel()}
        onOk={() => {
          handleSubmit({
            ...overall,
            remarks,
          });
        }}
      >
        <Row
          className="removal-acept"
          style={{ border: 'none', marginBottom: 20 }}
          gutter={12}
        >
          <Col span={12}>
            <span>Overall Acceptance</span>
          </Col>
          <Col span={12}>
            <Radio.Group
              options={optionsAccept}
              defaultValue={true}
              onChange={(e: any) =>
                setOverall({ overallAcceptance: e.target.value })
              }
            />
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <p className="label-normal">Remarks (Optional)</p>
            <TextArea
              className="remark-area"
              rows={4}
              placeholder={'Maximum 250 characters'}
              maxLength={250}
              onChange={(e: any) => setRemarks(e.target.value)}
            />
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default PopupFinalSubmitQaqc;
